<script lang="ts">
	import { afterNavigate } from '$app/navigation';
	import { page } from '$app/state';
	import { crossfade } from 'svelte/transition';

	interface Props {
		navItems: { label: string; url: string }[];
	}

	let { navItems }: Props = $props();

	afterNavigate(() => {
		const activeTab = document.querySelector('.tab-nav-item.active');

		if (activeTab) {
			activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
		}
	});

	const [send, receive] = crossfade({});
</script>

<nav class="border-b-gray-light scrollbar-hide w-full overflow-auto border-b-2 whitespace-nowrap">
	<ul class="card-bold text-gray-mid flex">
		{#each navItems as navItem (navItem.label)}
			<li class="tab-nav-item" class:active={page.url.pathname === navItem.url}>
				<a href={navItem.url} class="p-3 lg:px-8">
					{navItem.label}
					{#if page.url.pathname === navItem.url}
						<div
							class="bg-green-primary absolute bottom-0 left-0 h-1 w-full"
							in:receive={{ key: 'underline' }}
							out:send={{ key: 'underline' }}
						></div>
					{/if}
				</a>
			</li>
		{/each}
	</ul>
</nav>

<style lang="postcss">
	@reference '../app.css';

	li.tab-nav-item {
		@apply relative flex justify-center;

		&:hover {
			@apply text-green-primary;
		}

		&.active {
			@apply text-green-primary;
		}
	}
</style>
